import { noop as e } from "es-toolkit/function";
import { AnimatePresence as t, motion as n } from "motion/react";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/collapse/Collapse.tsx
var i = 200, a = (a) => {
	let { open: o = !1, unmountOnExit: s = !1, appear: c = !1, timeout: l = i, onEntered: u = e, onExited: d = e, onAnimationStart: f = e, children: p } = a;
	return /* @__PURE__ */ r(t, {
		initial: c,
		mode: "wait",
		children: (o || !s) && /* @__PURE__ */ r(n.div, {
			initial: "collapsed",
			animate: o ? "open" : "collapsed",
			exit: "collapsed",
			className: "collapse display-block width-100pct",
			variants: {
				open: {
					opacity: 1,
					height: "auto"
				},
				collapsed: {
					opacity: 0,
					height: 0
				}
			},
			transition: {
				duration: l / 1e3,
				ease: "easeIn"
			},
			onAnimationComplete: (e) => {
				e === "open" && u(), e === "collapsed" && d();
			},
			onAnimationStart: () => f(),
			children: p
		}, "content")
	});
};
//#endregion
export { a as default };

//# sourceMappingURL=Collapse.js.map